<script>
import {
  pageTitleMixin,
  prefetchDataMixin,
} from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import IconPlus from '@/components/icons/Plus';
import service from './service';

export default {
  pageTitle: 'Список проектов',
  async prefetchData () {
    if (!this.hasReadPermission) {
      return;
    }

    this.isFetching = true;

    this.list = await service.getList();
    this.listArchive = await service.getListArchive();

    this.isFetching = false;
  },
  mixins: [
    pageTitleMixin,
    prefetchDataMixin,
  ],
  data () {
    return {
      isFetching: false,
      list: [],
      listArchive: [],
    };
  },
  computed: {
    hasReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.PROJECT_READ);
    },
    hasWritePermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.PROJECT_WRITE);
    },
  },
  methods: {
    handleChildrenViewClose () {
      this.$_setTitle();
    },
    async handleDataUpdate () {
      this.list = await service.getList();
      this.listArchive = await service.getListArchive();
    },
  },
  render () {
    if (!this.hasReadPermission) {
      return (
        <ErrorAccessDenied />
      );
    }

    if (this.isFetching) {
      return <u-spinner />;
    }

    const { $style, list, listArchive } = this;

    return (
      <div>
        <u-title class="page-header">
          <span>
            Список проектов
          </span>

          {this.hasWritePermission && (
            <router-link
              class="u-btn u-btn_outline u-btn_square u-btn_primary"
              to="/projects/create"
            >
              <IconPlus />
            </router-link>
          )}
        </u-title>

        <u-table>
          {list.map(project => (
            <u-tr key={project.id}>
              <u-td>
                <router-link to={`/projects/${project.id}`}>
                  {project.name}
                </router-link>
              </u-td>
              <u-td class={$style.searchText}>
                {project.search || ''}
              </u-td>
            </u-tr>
          ))}
        </u-table>

        <u-title class="page-header">
          <span>
            Список архивных проектов
          </span>
        </u-title>

        <u-table>
          {listArchive.map(project => (
            <u-tr key={project.id}>
              <u-td>
                <router-link to={`/projects/${project.id}`}>
                  {project.name}
                </router-link>
              </u-td>
              <u-td class={$style.searchText}>
                {project.search || ''}
              </u-td>
            </u-tr>
          ))}
        </u-table>

        <router-view
          onClose={this.handleChildrenViewClose}
          onDataupdate={this.handleDataUpdate}
        />
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.searchText {
  color: $color-gray-darker;
}
</style>
